import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Notifier, { openSnackbar } from './notifier';
import api from '../api/backend'

const styles = theme => ({
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardContent: {
        flexGrow: 1,
    },
    form: {
        width: '100%', // Fix IE11 issue.
        marginTop: theme.spacing.unit,
    },
});

class CourseEditor extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { title: '', description: '', instructor: '', deactivated: false, course: {} }
    }

    handleSubmit = (event) => {
        const { history } = this.props
        const { title, description, instructor } = this.state
        event.preventDefault();

        api.createCourse({ Title: title, Description: description, Instructor: instructor }).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ title: json.title, description: json.description, instructor: json.instructor, deactivated: json.deactivated, course: json })
                openSnackbar({ message: 'สร้างคอร์สสำเร็จ' })
            } else {
                console.error('ไม่สามารถสร้างคอร์สใหม่ได้')
                openSnackbar({ message: 'ไม่สามารถสร้างคอร์สใหม่ได้' })
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
            openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
        })
        history.push('/editCourse/1')
    }

    handleUpdate = (event) => {
        const { title, description, instructor, course } = this.state
        event.preventDefault();

        api.updateCourse(course.id, { Title: title, Description: description, Instructor: instructor }).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ title: json.title, description: json.description, instructor: json.instructor, deactivated: json.deactivated, course: json })
                openSnackbar({ message: 'บันทึกคอร์สสำเร็จ' })
            } else {
                console.error('ไม่สามารถบันทึกคอร์สได้')
                openSnackbar({ message: 'ไม่สามารถบันทึกคอร์สได้' })
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
            openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
        })

    }

    getCourse = (courseId) => {
        if (courseId) {
            api.getCourse(courseId).then(([response, json]) => {
                if (response.status === 200) {
                    console.log(json)
                    const { course } = json
                    this.setState({
                        title: course.title, description: course.description, instructor: course.instructor,
                        deactivated: course.deactivated, course: course
                    })
                } else {
                    console.error(`ไม่สามารถรับค่าจากคอร์ส ${courseId} ได้`)
                }
            }).catch(() => {
                console.error('ไม่สามารถเชื่อมต่อ service ได้')
            })
        }
    }

    componentDidMount() {
        const { courseId } = this.props
        this.getCourse(courseId)
    }

    componentDidUpdate(prevProps) {
        console.log(this.props.courseId, prevProps.courseId)
        if (this.props.courseId !== prevProps.courseId) {
            this.getCourse(this.props.courseId)
        }
    }

    render() {
        const { classes } = this.props
        const { title, description, instructor, deactivated, course } = this.state
        return (
            <React.Fragment>
                <Notifier />
                <Card className={classes.card}>
                    <CardHeader
                        title={<Typography variant="title" gutterBottom>
                            เพิ่มและแก้ไขคอร์ส
                            </Typography>} />
                    <CardContent className={classes.cardContent}>
                        <form className={classes.form} onSubmit={this.handleSubmit}>
                            <Grid container spacing={24}>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="title"
                                        name="title"
                                        label="หัวข้อ"
                                        fullWidth
                                        autoComplete="course title"
                                        value={title}
                                        onChange={(event) => { this.setState({ title: event.target.value }) }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="description"
                                        name="description"
                                        label="รายละเอียด"
                                        fullWidth
                                        multiline
                                        rows={10}
                                        autoComplete="course description"
                                        value={description}
                                        onChange={(event) => { this.setState({ description: event.target.value }) }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        required
                                        id="instructor"
                                        name="instructor"
                                        label="ผู้สอน"
                                        fullWidth
                                        autoComplete="course instructor"
                                        value={instructor}
                                        onChange={(event) => { this.setState({ instructor: event.target.value }) }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={<Checkbox color="secondary" name="deactivated" value={`${deactivated}`}
                                            onChange={(event) => { this.setState({ deactivated: event.target.value }) }} />}
                                        label="ยกเลิกคอร์ส"
                                    />
                                </Grid>
                            </Grid>
                            {course.id ? <Button
                                variant="raised"
                                color="primary"
                                fullWidth
                                className={classes.submit}
                                onClick={this.handleUpdate}
                            >
                                บันทึก
                            </Button> : <Button
                                    type="submit"
                                    variant="raised"
                                    color="primary"
                                    fullWidth
                                    className={classes.submit}
                                >
                                    สร้างคอร์ส
                            </Button>}
                        </form>
                    </CardContent>
                </Card>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(CourseEditor);